import { useEffect, useMemo } from 'react'

import { normalizeToEl, RefOrEl } from '../utilities/normalize-to-el'

export const useClickAway = (
  containerRefOrRefs: RefOrEl<HTMLElement | null> | RefOrEl<HTMLElement | null>[],
  onClickAway: () => void,
  events: string[] = ['mousedown', 'touchstart'],
) => {
  const containerRefs = useMemo(
    () => (!(containerRefOrRefs instanceof Array) ? [containerRefOrRefs] : containerRefOrRefs),
    [containerRefOrRefs],
  )

  const bindDoc = () => {
    const handleEvent = (event: Event) => {
      if (!event.target) return
      const isClickOutside = containerRefs.every(
        (r) => !normalizeToEl(r)?.contains(event.target as Node),
      )
      if (isClickOutside) onClickAway()
    }

    for (const eventName of events) document.addEventListener(eventName, handleEvent)

    return () => {
      for (const eventName of events) document.removeEventListener(eventName, handleEvent)
    }
  }

  useEffect(bindDoc, [events, onClickAway, containerRefs])
}
